import styled from 'styled-components';
import {dFlex, alignCenter, justifyCenter} from '../../../../globalVariables/GlobalFlex';
import {
    AI_BRAND_GRADIENT_HORIZONTAL,
    AI_BRAND_GRADIENT_HORIZONTAL_HOVER,
} from '../../../aiMessageGenerator/aiGeneratorButton/AIGeneratorButton.css';

/**
 * Same pill as the confirm button it replaces in the bubble, so the chat's one action keeps
 * its place; sits above the feedback card when both are shown.
 */
export const goToPageButton = styled.button`
    ${dFlex}
    ${alignCenter}
    ${justifyCenter}
    gap: var(--space-xs);
    width: 100%;
    margin-bottom: var(--space-sm);
    padding: var(--space-sm) var(--space-lg);
    border: none;
    border-radius: 100px;
    background: ${AI_BRAND_GRADIENT_HORIZONTAL};
    color: var(--color-text-inverse-default);
    font-family: inherit;
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-bold);
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover:not(:disabled) {
        background: ${AI_BRAND_GRADIENT_HORIZONTAL_HOVER};
    }

    &:disabled {
        cursor: default;
        opacity: 0.5;
    }

    &:last-child {
        margin-bottom: 0;
    }
`;

/** Points the way the page opens: forward in the reading direction. */
export const arrow = styled.span`
    font-size: 1.25em;
    line-height: 1;

    [dir='rtl'] & {
        transform: scaleX(-1);
    }
`;
